import styled from 'styled-components';

import { AbsoluteImage } from './AbsoluteImage';

export interface InputStyledProps {
  width?: string;
  marginBottom?: number;
  height?: string;
  autocomplete?: string;
  maxWidth?: string;
  minWidth?: string;
}

export const InputStyled = styled.input<InputStyledProps>`
  box-sizing: border-box;
  position: relative;
  height: 100%;
  width: 100%;
  transition: 0.3s;
  color: ${({ theme }) => theme.colors.black};
  font-weight: bold;
  cursor: pointer;
  outline: none;
  padding: 17px;
  border: none;
  background-color: transparent;

  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const PlaceHolderIcon = styled(AbsoluteImage)`
  right: 20px;
  top: 30%;
`;

export const Label = styled.label`
  position: absolute;
  top: -20px;
  cursor: pointer;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.darkGray};
  margin-left: 17px; // Better alignment with input fields
`;
